/**
 * Returns the appropriate home route based on the user's contracts and selected contract type.
 * parameter_menu: 0 — НЭСК, 2 — ГП, 3 — ФИКС; может быть составным ("2,4").
 *
 * @param {Array} dogovors
 * @param {Object|null} selectedDog
 * @returns {string}
 */
export function getHomeRoute(dogovors, selectedDog) {
  if (!dogovors || dogovors.length === 0) return '/home';
  const menus = String(selectedDog?.parameter_menu ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  if (menus.includes('2') || menus.includes('3')) return '/dogovor-actions'; // ГП, ФИКС
  return '/dogovor'; // 0 — НЭСК
}

/**
 * Safe post-login redirect from ?next= query.
 * Allows only same-app relative paths (blocks open redirects).
 *
 * @param {string} [search] location.search, e.g. "?next=%2Fletters"
 * @returns {string|null}
 */
export function getSafeNextPath(search) {
  if (!search) return null;
  const next = new URLSearchParams(search).get('next');
  if (!next || !next.startsWith('/') || next.startsWith('//') || next.startsWith('/login')) {
    return null;
  }
  return next;
}

/**
 * Login URL that remembers where the user wanted to go.
 *
 * @param {string} pathname
 * @param {string} [search]
 * @returns {{ pathname: string, search?: string }}
 */
export function getLoginRedirectLocation(pathname, search = '') {
  const next = `${pathname || '/'}${search || ''}`;
  if (!next || next === '/' || next.startsWith('/login')) {
    return { pathname: '/login' };
  }
  return {
    pathname: '/login',
    search: `?next=${encodeURIComponent(next)}`,
  };
}
